module.exports = __webpack_public_path__ + "img/Legacy.f9961cb3.jpeg";